import { defineComponent } from "vue";
import { NSpin } from "naive-ui";

export default defineComponent({

  components: {
    NSpin,
  },

  props: {
    title: { type: String, required: false },
    empty: { type: Boolean, default: false },
    padding: { type: Boolean, default: true },
  },
})